/*
 * @Description: 技-师管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2021-07-06 18:30:52
 * @LastEditTime: 2023-12-22 16:35:20
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 技-师数据统计
  coachDataList (querys) {
    return get('massage/admin/AdminCoach/coachDataList', querys)
  },
  // 门店下拉框
  storeSelect (querys) {
    return get('store/admin/AdminStore/storeSelect', querys)
  },
  // 技-师列表
  coachList (querys) {
    return get('massage/admin/AdminCoach/coachList', querys)
  },
  // 技-师详情
  coachInfo (querys) {
    return get('massage/admin/AdminCoach/coachInfo', querys)
  },
  // 技-师统计详情
  coachCashData (querys) {
    return get('massage/admin/AdminCoach/coachCashData', querys)
  },
  // 审核认证
  coachAuthCheck (querys) {
    return post('massage/admin/AdminCoach/coachAuthCheck', querys)
  },
  // 技-师审核(status2通过,3拒绝,sh_text)
  coachUpdate (querys) {
    return post('massage/admin/AdminCoach/coachUpdate', querys)
  },
  // 技-师详情
  coachUpdateInfo (querys) {
    return get('massage/admin/AdminCoach/coachUpdateInfo', querys)
  },
  // 技-师审核(status2通过,3拒绝,sh_text)
  coachUpdateCheck (querys) {
    return post('massage/admin/AdminCoach/coachUpdateCheck', querys)
  },
  // 添加水印图片
  addWatermarkImg (querys) {
    return post('massage/admin/AdminCoach/addWatermarkImg', querys)
  },
  // 获取水印图片
  WatermarkImgInfo (querys) {
    return get('massage/admin/AdminCoach/WatermarkImgInfo', querys)
  },
  // 关联用户
  coachUserList (querys) {
    return get('massage/admin/AdminCoach/coachUserList', querys)
  },
  // 技-师关联服务
  coachServiceList (querys) {
    return get('massage/admin/AdminCoach/coachServiceList', querys)
  },
  // 技-师未关联服务
  coachNoServiceList (querys) {
    return get('massage/admin/AdminCoach/coachNoServiceList', querys)
  },
  // 关联服务
  addCoachService (querys) {
    return post('massage/admin/AdminCoach/addCoachService', querys)
  },
  // 取消关联
  delCoachService (querys) {
    return post('massage/admin/AdminCoach/delCoachService', querys)
  },
  // 修改服务价格
  updateCoachServicePrice (querys) {
    return post('massage/admin/AdminCoach/updateCoachServicePrice', querys)
  },
  // 新增技-师
  coachAdd (querys) {
    return post('massage/admin/AdminCoach/coachAdd', querys)
  },
  // 编辑技-师
  coachDataUpdate (querys) {
    return post('massage/admin/AdminCoach/coachDataUpdate', querys)
  },
  // 编辑经纪人
  updateCoachBroker (querys) {
    return post('massage/admin/AdminCoach/updateCoachBroker', querys)
  },
  // 代理商编辑技-师
  coachUpdateAdmin (querys) {
    return post('massage/admin/AdminCoach/coachUpdateAdmin', querys)
  },
  // 技-师等级列表
  levelList (querys) {
    return get('massage/admin/AdminCoach/levelList', querys)
  },
  // 技-师等级详情
  levelInfo (querys) {
    return get('massage/admin/AdminCoach/levelInfo', querys)
  },
  // 新增技-师等级
  levelAdd (querys) {
    return post('massage/admin/AdminCoach/levelAdd', querys)
  },
  // 编辑技-师等级
  levelUpdate (querys) {
    return post('massage/admin/AdminCoach/levelUpdate', querys)
  },
  // 信用分
  creditConfigInfo (querys) {
    return get('massage/admin/AdminSetting/creditConfigInfo', querys)
  },
  // 信用分设置
  creditConfigUpdate (querys) {
    return post('massage/admin/AdminSetting/creditConfigUpdate', querys)
  },
  // 挂件图标列表
  coachIconList (querys) {
    return get('massage/admin/AdminSetting/coachIconList', querys)
  },
  // 挂件图标详情
  coachIconInfo (querys) {
    return get('massage/admin/AdminSetting/coachIconInfo', querys)
  },
  // 新增挂件图标
  coachIconAdd (querys) {
    return post('massage/admin/AdminSetting/coachIconAdd', querys)
  },
  // 编辑挂件图标
  coachIconUpdate (querys) {
    return post('massage/admin/AdminSetting/coachIconUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/technician.js